<template>
  <div class="navW">
    <div class="nav">
      <div class="iconfont icon-fanhui" v-if="isBack" @click="back()"></div>
      <div class="iconfont icon-shouye" v-else></div>
      <img src="~@/assets/img/logo.png">
      <div class="menu" @click="is_show = !is_show">菜单</div>
    </div>
    <div class="nav_ul" v-show="is_show" @click="is_show = !is_show">
      <ul class="nav_ulD" @click.stop="">
        <li v-for="(i,index) in list" :key="index" :class="{'action': url == i.url}">
          <div class="liD" @click="jump(index)"><span class="iconfont" :class="i.img"></span>{{i.name}}<span v-if="i.list" class="iconfont icon-xialajiantou" :class="{'icon-action': i.show}"></span></div>
          <ul v-if="i.show&&i.list">
            <li v-for="(k,index) in i.list" :key="index" :class="{'action': url == k.url}" @click="jumpp(k.url)">{{k.name}}</li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'navG',
  props: {
    isBack: Boolean,
    isNum: Number
  },
  data () {
    return {
      is_show: false,
      list: [{
        img: 'icon-shouye',
        name: '赛兰首页',
        url: 'index.html'
      }, {
        img: 'icon-diannaodianqi',
        name: '瀚礼网',
        url: 'hanli.html'
      }, {
        img: 'icon-dingzhi',
        name: '礼品定制',
        url: 'gift.html'
      }, {
        img: 'icon-fuliguanli',
        name: '企业福利',
        url: 'welfare.html'
      }, {
        img: 'icon-gongyinglian',
        name: '供应链专区',
        url: 'gylI.html'
      }, {
        img: 'icon-xitongguanli',
        name: '系统赋能',
        list: [{
          name: '社区内购',
          url: 'xtneigou.html'
        },{
          name: '积分商城',
          url: 'xtjifen.html'
        }],
        show: false
      }, {
        img: 'icon-guanyuwomen',
        name: '关于我们',
        list: [{
          name: '企业简介',
          url: 'companyProfile.html'
        }, {
          name: '新闻中心',
          url: 'news.html'
        }, {
          name: '供应链招募',
          url: 'aboutRecruit.html'
        }, {
          name: '联系我们',
          url: 'aboutContact.html'
        }, {
          name: '社区团长招募',
          url: 'xtneigou.html'
        }],
        show: false
      }],
      url: ''
    }
  },
  mounted () {
    this.url = decodeURIComponent(location.href.split('/')[3]);
    for(let i=0;i<this.list.length;i++) {
      if (this.list[i].list) {
        for(let k=0;k<this.list[i].list.length;k++) {
          if (this.list[i].list[k].url == this.url) {
            this.list[i].show = true
          }
        }
      }
    }
  },
  methods: {
    back () {
      window.history.go(-1)
    },
    jump (i) {
      if (this.list[i].list) {
        this.list[i].show = !this.list[i].show
      } else {
        location.href = this.list[i].url
      }
    },
    jumpp (url) {
      if (url == null) {
      } else {
        location.href = url
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.navW
  height px(80)
.nav
  display flex
  height px(80)
  align-items center
  justify-content space-between
  position fixed
  top 0px
  left 0px
  width 100%
  z-index 111
  background #fff
  .iconfont
    margin 0 px(20)
    font-size px(35)
  img
    height px(50)
  .menu
    font-size px(32)
    color #333
    height px(80)
    padding 0 .2rem
    line-height px(80)
.nav_ul
  width 100%
  height 100%
  position fixed
  top 0
  right 0px
  background rgba(0,0,0,.4)
  z-index 99
  padding-top px(80)
  .nav_ulD
    width px(480)
    height 100%
    background #fff
    position absolute
    right 0
    overflow auto
    li
      .liD
        height px(140)
        line-height px(140)
        font-size px(32)
        color #333333
        padding-left px(30)
        position relative
        .iconfont
          font-size px(42)
          margin-right px(60)
        .icon-xialajiantou
          font-size .2rem
          color #999999
          position absolute
          right .3rem
          transform rotate(0deg)
        .icon-action
          transform rotate(180deg)
      ul
        width 100%
        li
          height px(80)
          line-height px(80)
          padding-left px(133)
          font-size px(28)
        li.action
          background #F4F5F7
    li.action
      .liD
        background #F4F5F7          
</style>



// WEBPACK FOOTER //
// src/components/navG.vue